import { FC } from 'react'

import { ErrorRouteComponent } from '@tanstack/react-router'

import { Spinner } from '@forto-dev/phoenix-ui-core'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back'
import { createErrorFallback } from '@/fragments/create-error-fallback'
import { Footer } from '@/fragments/footer.tsx'
import { Header } from '@/fragments/header.tsx'

export const RequiredActionsLayout: FC = () => {
  return <Layout header={<Header />} navigation={<Back to="/" />} main={<Spinner size="lg" />} footer={<Footer />} />
}
export const RequiredActionsErrorComponent: ErrorRouteComponent = ({ error, reset }) => {
  return (
    <Layout
      header={<Header />}
      navigation={<Back to="/" />}
      main={createErrorFallback(`An error occurred while loading Required Actions`)({ error, reset })}
      footer={<Footer />}
    />
  )
}
